import styled from 'styled-components';
import Button from '../../../components/Button';
import theme from '../../../styles/defaultTheme';

export const Container = styled.div`
    min-width: 100vw;
    height: 100vh;
    background-image: url("https://homologacao1.gndi.com.br/login/img/suporte_background.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom;
    display: flex;
`;

export const ContainerCard = styled.div`
    align-content: center;
    border-radius: 8px;
    width: 470px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 4px 4px 16px #00000029;
    margin: auto;
    padding: 0px 45px;
`;

export const Logo = styled.div`
    display: flex;
    justify-content: center;
    padding: 24px 0;
`;

export const Divider = styled.div`
   display: flex;
   justify-content: space-between;
   flex-direction: row;
   margin: 24px 0;
`;

export const LineDivider = styled.div`
    border-bottom: solid 1px #5B5B5F;
    width: 46%;
    margin-bottom: 8px;
`;

export const Text = styled.div`
    text-align: center;
    color: #5B5B5F;
`;

export const Error = styled.div`
    text-align: start;
    color: ${(props) => props.theme.red};
    margin-bottom: 5px;
`;

export const Title = styled.h1`
    font-size: ${theme.font.size21};
    color: ${(props) => props.theme.black};
    font-weight: bold;
    text-align: center;
`;

export const SubTitle = styled.h2`
    font-size: ${theme.font.size16};
    color: #5b5b5f;
    text-align: center;
    margin-bottom: 24px;
`;

export const StyledButton = styled(Button)`
   width: 100%;
   margin: 32px 0px;

   :hover {
        opacity: 80%;
        cursor: pointer;
    }
`;
